import React, { FC } from "react";
import Spinner from "./Spinner";
import { type } from "os";
import Skeleton from "react-loading-skeleton";

type Props = {
  title?: string;
  type?: string;
  className?: string;
};

const Loader: FC<Props> = ({ title, type, className }) => {
  if (type === "header") {
    return (
      <div className={`flex gap-4 relative ${className} `}>
        <Skeleton
          count={1}
          containerClassName="h-full w-full !flex overflow-hidden  absolute inset-0 flex gap-2 w-full "
          // className="2xl:min-w-[1194px] min-w-[100vw] !w-auto flex flex-grow flex-1 align-top mx-2 transform -translate-x-full relative aspect-slider"

          className="w-full "
        />
      </div>
    );
  }
  if (type === "square") {
    return (
      <div
        className={`relative w-full cursor-pointer items-center gap-2.5 flex h-[46px] overflow-hidden text-white border rounded border-primary-500 shadow-card bg-primary-900 hover:bg-primary-500 transition-all text-left   ${className}`}
      >
        <Skeleton
          // count={3}
          containerClassName="h-full w-full !flex overflow-hidden  absolute inset-0"
          // className="2xl:min-w-[1194px] min-w-[100vw] !w-auto flex flex-grow flex-1 align-top mx-2 transform -translate-x-full relative aspect-slider"
        />
      </div>
    );
  }
  if (type === "round") {
    return (
      <div
        className={` relative w-full cursor-pointer items-center gap-2.5 flex h-[46px] overflow-hidden text-white border rounded border-primary-500 shadow-card bg-primary-900 hover:bg-primary-500 transition-all text-left   ${className}`}
      >
        <Skeleton
          // count={3}
          containerClassName="rounded-full h-full w-full !flex overflow-hidden  absolute inset-0"
          // className="2xl:min-w-[1194px] min-w-[100vw] !w-auto flex flex-grow flex-1 align-top mx-2 transform -translate-x-full relative aspect-slider"
        />
      </div>
    );
  }
  if (type === "text") {
    return (
      <div
        className={`relative w-full cursor-pointer items-center gap-2.5 flex h-7 overflow-hidden text-white rounded bg-primary-900   ${className}`}
      >
        <Skeleton
          // count={3}
          containerClassName="h-full w-full !flex overflow-hidden  absolute inset-0"
          // className="2xl:min-w-[1194px] min-w-[100vw] !w-auto flex flex-grow flex-1 align-top mx-2 transform -translate-x-full relative aspect-slider"
        />
      </div>
    );
  }
  return (
    <div className="loading">
      <div className="spinner-wrapper">
        <Spinner />
        {title && <div className="title">{title}</div>}
      </div>
    </div>
  );
};

export default Loader;

export { Spinner };
